import React from "react";

type Props = React.SVGProps<SVGSVGElement>;

export default function CustomReportIcon(props: Props) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill="#EEE9FF" />
      <rect
        x="0.5"
        y="0.5"
        width="39"
        height="39"
        rx="19.5"
        stroke="url(#paint0_linear_1753_8953)"
      />
      <path
        d="M21.7325 15.648C22.548 14.968 23.4091 13.9493 23.4091 12.6667V12H16.5909V12.6667C16.5909 13.9493 17.452 14.9673 18.2675 15.648C15.0595 16.766 12.5 20.7493 12.5 24C12.5 26.206 14.3348 28 16.5909 28H23.4091C25.6652 28 27.5 26.206 27.5 24C27.5 20.7493 24.9405 16.766 21.7325 15.648ZM18.0957 13.3333H21.9023C21.547 14.1707 20.6136 14.8733 20.0048 15.2347C19.492 14.928 18.47 14.2267 18.0964 13.3333H18.0957ZM23.4091 26.6667H16.5909C15.0868 26.6667 13.8636 25.4707 13.8636 24C13.8636 20.5593 16.9932 16.678 19.9986 16.678C23.0041 16.678 26.1364 20.56 26.1364 24C26.1364 25.4707 24.9132 26.6667 23.4091 26.6667ZM18.6364 20.6667C18.6364 20.9187 18.8211 21.132 19.0755 21.1733L21.1495 21.5113C22.0639 21.66 22.728 22.4267 22.728 23.3333C22.728 24.436 21.8102 25.3333 20.6825 25.3333V26H19.3189V25.3333C18.1911 25.3333 17.2734 24.436 17.2734 23.3333H18.637C18.637 23.7007 18.9432 24 19.3189 24H20.6825C21.0582 24 21.3643 23.7007 21.3643 23.3333C21.3643 23.0813 21.1795 22.868 20.9252 22.8267L18.8511 22.4887C17.9368 22.34 17.2727 21.5733 17.2727 20.6667C17.2727 19.564 18.1905 18.6667 19.3182 18.6667V18H20.6818V18.6667C21.8095 18.6667 22.7273 19.564 22.7273 20.6667H21.3636C21.3636 20.2993 21.0575 20 20.6818 20H19.3182C18.9425 20 18.6364 20.2993 18.6364 20.6667Z"
        fill="#784EFF"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1753_8953"
          x1="20"
          y1="0"
          x2="20"
          y2="40"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BBA7FF" />
          <stop offset="1" stop-color="#BBA7FF" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
